import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import type { LoginRequestDto } from '@evimo/client';
import { AuthService } from '~/app/auth/services/auth.service';
import { useAuth } from '~/app/auth/context/AuthContext';
import { getRoleRedirectPath } from '~/app/auth/utils';

export function useLogin() {
  const navigate = useNavigate();
  const { refetchUser } = useAuth();

  return useMutation<void, Error, LoginRequestDto>({
    mutationFn: async (data) => {
      await AuthService.login(data);
    },
    onSuccess: async () => {
      const { data: me } = await refetchUser();
      navigate(getRoleRedirectPath(me?.roleName), { replace: true });
    },
  });
}
